import RMModal from 'components/modal/RMModal';
import React, { useState, useEffect } from 'react';
import { AutoUpdateJsonFormat, getReleaseNotesFromUrl } from './AutoUpdate.BL';
import { Spinner } from 'react-bootstrap';
import { isAdministrator } from 'utils/Global';
import { setShowUpgradeFallbackDialog } from 'redux/reducers/commonReducer';
import { useRMDispatch } from 'redux/hooks';
import { FmlxModal } from 'fmlx-common-ui';

function AutoUpdateDialog(props) {
  const { params }: { params: AutoUpdateJsonFormat } = props;
  const [showDialog, setShowDialog] = useState(true);
  const [loadingRelaseNotes, setLoadingRelaseNotes] = useState(true);
  const [releaseNotes, setReleaseNotes] = useState('');
  const dispatch = useRMDispatch();

  useEffect(() => {
    async function getReleaseNotes(url) {
      const notes: any = await getReleaseNotesFromUrl(url);
      const val = await notes.data?.text();
      setReleaseNotes(val);
      setLoadingRelaseNotes(false);
    }

    if (params?.release_notes) {
      getReleaseNotes(params.release_notes);
    }
  }, [params?.release_notes]);

  const bodyComponent = () => {
    return (
      <div id='dashboard-autoupdate-bodycomponent-container'>
        {loadingRelaseNotes ? (
          <div id='dashboard-autoupdate-bodycomponent-realasenote' style={{ display: 'flex', justifyContent: 'center', height: '50px' }}>
            <Spinner id='dashboard-autoupdate-bodycomponent-releasenote-spinner' animation={'border'} />
          </div>
        ) : (
          <div id='dashboard-autoupdate-bodycomponent-realasenote-message'
            style={{
              display: 'flex',
              justifyContent: 'center',
              height: '433px',
              whiteSpace: 'pre-line',
            }}
          >
            {' '}
            {`RockMaker Release Notes: \r\n${releaseNotes}`}{' '}
          </div>
        )}
      </div>
    );
  };

  return (
    <RMModal id='dashboard-autoupdate-wrapper'
      showModal={showDialog}
      scrollable={true}
      setShowModal={() => {
        setShowDialog(false);
        dispatch(setShowUpgradeFallbackDialog(false));
      }}
      onOk={() => (isAdministrator() ? window.open(params?.url) : setShowDialog(false))}
      body={bodyComponent()}
      heading={'RockMaker Update'}
      titleClr={'#1B1B1B'}
      isOkOnly={true}
      onCancel={() => {
        setShowDialog(false);
      }}
      dialogClassName="modal-lg"
      okButtonText={isAdministrator() ? 'Download' : 'Ok'}
      showFooterSeparator={true}
      size={FmlxModal.Size.EXTRA_LARGE}
    />
  );
}

export default AutoUpdateDialog;
